import type { Except } from "type-fest";
import { z } from "zod";
import type { Price} from "../prices/price";
import { priceZodSchema } from "../prices/price";
import type {
    Amount} from "../units-and-quantities/amount";
import {
    amountZodSchema,
    defaultAmount,
} from "../units-and-quantities/amount";

type Buyable = {
    readonly _type: "BUYABLE";
    readonly price: Price;
    /**
     * Quantity amount thats i bought per bookable item \
     * For a bookable, this is always 1 \
     * For a buyable, this could shift. \
     *
     * E.g. A shirt could have 5 pcs in stock \
     * A sku could be a two-pack of shirts. \
     * When you buy 1 of the sku, the amount (below) is 2 \
     * Two shirts in stock is required to buy one of the sku
     * @type {Amount}
     */
    readonly amount: Amount;
    readonly minQuantity: number | null;
};

type FactoryParams = Except<Buyable, "_type" | "amount" | "minQuantity">;
const buyableFactory = (
    params: FactoryParams & {
        readonly amount?: Amount;
        readonly minQuantity?: number | null;
    },
): Buyable => {
    const { amount, price, minQuantity } = params;
    return {
        price,
        _type: "BUYABLE",
        amount: amount || defaultAmount,
        minQuantity: minQuantity || null,
    };
};

const buyableZodSchema: z.ZodSchema<Buyable> = z.object({
    _type: z.literal("BUYABLE"),
    price: priceZodSchema,
    amount: amountZodSchema,
    minQuantity: z.number().nullable(),
});

// const isBuyable = (acquirable: { _type: unknown }): acquirable is Buyable => {
//     return acquirable._type === "BUYABLE";
// };

export { buyableFactory, buyableZodSchema as buyableZodObject };
export type { Buyable };
